import { Action } from 'redux';
import { ContractConceptCategoryState, ContractConceptCategoryUnloadState } from '../states/ContractConceptCategoryState';
import { ContractConceptCategory } from '../../models/Entities/Contracts/ContractConceptCategory';
import { ContractConceptCategoryAction } from '../actions/ContractConceptCategory.Actions';

const byName = (a: ContractConceptCategory, b: ContractConceptCategory) =>
    (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' });

export default function ContractConceptCategoryReducer(
    state: ContractConceptCategoryState | undefined,
    incoming: Action
): ContractConceptCategoryState {
    const current = state ?? ContractConceptCategoryUnloadState;
    const action = incoming as ContractConceptCategoryAction;

    switch (action.type) {
        case 'CONTRACT_CONCEPT_CATEGORY_GET_ALL_REQUEST_ACTION':
            return { ...current, isLoadingAll: true, successLoadingAll: undefined, failOnLoadingAll: false, error: undefined };
        case 'CONTRACT_CONCEPT_CATEGORY_GET_ALL_RECEIVE_ACTION':
            return { ...current, isLoadingAll: false, successLoadingAll: true, failOnLoadingAll: false, list: [...(action.categories ?? [])].sort(byName), error: undefined };
        case 'CONTRACT_CONCEPT_CATEGORY_GET_ALL_FAIL_ACTION':
            return { ...current, isLoadingAll: false, successLoadingAll: false, failOnLoadingAll: true, error: action.error };

        case 'CONTRACT_CONCEPT_CATEGORY_ADD_REQUEST_ACTION':
            return { ...current, isAddingNewOne: true, successAddingNewOne: undefined, failOnAddingNewOne: false, error: undefined };
        case 'CONTRACT_CONCEPT_CATEGORY_ADD_RECEIVE_ACTION':
            return {
                ...current,
                isAddingNewOne: false, successAddingNewOne: true, failOnAddingNewOne: false,
                list: action.category ? [...current.list.filter((item) => item.id !== action.category.id), action.category].sort(byName) : current.list,
                error: undefined
            };
        case 'CONTRACT_CONCEPT_CATEGORY_ADD_FAIL_ACTION':
            return { ...current, isAddingNewOne: false, successAddingNewOne: false, failOnAddingNewOne: true, error: action.error };

        case 'CONTRACT_CONCEPT_CATEGORY_UPDATE_REQUEST_ACTION':
            return { ...current, isUpdatingOne: true, successUpdatingOne: undefined, failOnUpdatingOne: false, error: undefined };
        case 'CONTRACT_CONCEPT_CATEGORY_UPDATE_RECEIVE_ACTION':
            return {
                ...current,
                isUpdatingOne: false, successUpdatingOne: true, failOnUpdatingOne: false,
                list: current.list.map((item) => (item.id === action.category.id ? { ...item, ...action.category } : item)).sort(byName),
                error: undefined
            };
        case 'CONTRACT_CONCEPT_CATEGORY_UPDATE_FAIL_ACTION':
            return { ...current, isUpdatingOne: false, successUpdatingOne: false, failOnUpdatingOne: true, error: action.error };

        case 'CONTRACT_CONCEPT_CATEGORY_DELETE_REQUEST_ACTION':
            return { ...current, isDeletingOne: true, successDeletingOne: undefined, failOnDeletingOne: false, deletingId: action.categoryId, error: undefined };
        case 'CONTRACT_CONCEPT_CATEGORY_DELETE_RECEIVE_ACTION':
            return {
                ...current,
                isDeletingOne: false, successDeletingOne: true, failOnDeletingOne: false, deletingId: undefined,
                list: current.list.filter((item) => item.id !== action.categoryId),
                error: undefined
            };
        case 'CONTRACT_CONCEPT_CATEGORY_DELETE_FAIL_ACTION':
            return { ...current, isDeletingOne: false, successDeletingOne: false, failOnDeletingOne: true, deletingId: action.categoryId, error: action.error };

        case 'CONTRACT_CONCEPT_CATEGORY_RESET_FLAGS_ACTION':
            return {
                ...current,
                successAddingNewOne: undefined, failOnAddingNewOne: false,
                successUpdatingOne: undefined, failOnUpdatingOne: false,
                successDeletingOne: undefined, failOnDeletingOne: false, deletingId: undefined,
                error: undefined
            };

        default:
            return current;
    }
}
